// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"960":"c604623aef44d052","2106":"85b05a7787b436df"}[chunkId] + ".js";
};